import { getMargin } from '@teinor/erp/prices/margin'
import { TwinParameters } from '@teinor/erp/types/company/config/parameter'
import { displayFormatedNumber } from '../../../utils/globals/numbers'
import { getConfigParam } from '../../../utils/reducers/getters'
import { RowData } from '../../../baseComponents/TwinTable/types'

interface DisplayMarginProps {
    allRowData: RowData
    cost: number
    className?: string
}

const DisplayMargin: React.FC<DisplayMarginProps> = ({allRowData, cost, className}) => {
    const typeMargin = getConfigParam('typeMargin')
    const limitMargin = getConfigParam('limitMargin') || 0
    const decimals = getConfigParam('decimals') as TwinParameters['decimals']
    const margin = getMargin( typeMargin || 0, allRowData.calculated_price, cost)
    const finalValue = margin.toFixed(decimals)
    const finalNumber = displayFormatedNumber(finalValue)
    return (<div className={margin > limitMargin ? 'text-green-43 ' : 'text-red-BA ' + (className||'')}>{finalNumber} %</div>)
}


export default DisplayMargin